import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const NurturingJourneyHowToUseInfo = () => (
  <Tooltip
    arrow
    placement="bottom-start"
    componentsProps={{
      tooltip: {
        sx: { maxWidth: 380 },
      },
    }}
    title={
      <Box sx={{ py: 0.25 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          How to use
        </Typography>
        <Typography variant="body2" component="div" sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
          <span>
            1) Switch <strong>Unsold</strong> / <strong>Sold</strong> to view each config; pick <strong>Segment</strong>.
          </span>
          <span>2) Select a stage tab to view or edit steps.</span>
          <span>
            3) Drag to reorder; set <strong>Max repeat</strong>.
          </span>
        </Typography>
      </Box>
    }
  >
    <IconButton
      size="small"
      aria-label="How to use nurturing journey settings"
      onClick={e => e.stopPropagation()}
      sx={{
        ml: 0.25,
        color: 'text.secondary',
        '&:hover': { color: 'primary.main', bgcolor: 'action.hover' },
      }}
    >
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);
